// src/ChevronUpCircleIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ChevronUpCircleIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.64648 14.2568C4.13123 14.2568 1.27148 11.3971 1.27148 7.88184C1.27148 4.36659 4.13123 1.50684 7.64648 1.50684C11.1617 1.50684 14.0215 4.36659 14.0215 7.88184C14.0215 11.3971 11.1617 14.2568 7.64648 14.2568ZM7.64648 0.381836C3.51098 0.381836 0.146484 3.74634 0.146484 7.88184C0.146484 12.0173 3.51098 15.3818 7.64648 15.3818C11.782 15.3818 15.1465 12.0173 15.1465 7.88184C15.1465 3.74634 11.782 0.381836 7.64648 0.381836Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.64603 6.14177C7.49678 6.14177 7.35278 6.20102 7.24778 6.30752L4.64453 8.92202C4.42478 9.14252 4.42628 9.49877 4.64603 9.71777C4.86653 9.93677 5.22278 9.93677 5.44178 9.71627L7.64603 7.50077L9.85103 9.71627C10.07 9.93677 10.4263 9.93677 10.6468 9.71777C10.8665 9.49877 10.8673 9.14252 10.6483 8.92202L8.04428 6.30752C7.93928 6.20102 7.79528 6.14177 7.64603 6.14177Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var ChevronUpCircleIcon_default = ChevronUpCircleIcon;

export {
  ChevronUpCircleIcon_default
};
